import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";
import {getErrorMessageHtml, getInputErrorClasses, hasFieldAnError} from "../../Utils/FormHelpers";

export const NumberInput = (props) => {
    const {
        register = null,
        name,
        translationIndex = null,
        errors,
        placeholder = '',
        type = 'number',
        onChange,
        step = 1,
        suffix = null
    } = props;
    const {t} = useTranslation();

    return (
        <div className={'my-2'}>
            {
                translationIndex !== null && (
                    <label htmlFor={name}
                           className="block text-left text-sm font-medium leading-6 text-gray-900">
                        {t(`${translationIndex}`)}
                    </label>
                )
            }
            <div className="relative rounded-md shadow-sm">
                {
                    register !== null && (
                        <input
                            {...register(name)}
                            id={name}
                            placeholder={placeholder}
                            name={name}
                            step={step}
                            type={type}
                            autoComplete={name}
                            className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${suffix ? 'pr-8' : ''} ${getInputErrorClasses(errors, name)}`}
                        />
                    )
                }

                {
                    register === null && (
                        <input
                            name={name}
                            type={type}
                            onChange={onChange}
                            step={step}
                            placeholder={placeholder}
                            autoComplete={name}
                            className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${suffix ? 'pr-8' : ''} ${getInputErrorClasses(errors, name)}`}
                        />
                    )
                }

                {
                    suffix && (
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                            <span className="text-gray-500 sm:text-sm">{suffix}</span>
                        </div>
                    )
                }

                {
                    hasFieldAnError(errors, name) && !suffix && (
                        <div
                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                            <ExclamationCircleIcon
                                className="h-5 w-5 text-red-500"
                                aria-hidden="true"/>
                        </div>
                    )
                }
            </div>

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}